// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  propertyIdentifier = 124,
  identifier = 125,
  nameIdentifier = 126,
  insertSemi = 127,
  LineComment = 1,
  BlockComment = 2,
  Expression = 3,
  expression0 = 131,
  ForExpression = 4,
  forExpressionStart = 134,
  _for = 5,
  ForInExpressions = 6,
  ForInExpression = 7,
  Name = 8,
  Identifier = 9,
  AdditionalIdentifier = 10,
  minus = 12,
  plus = 13,
  divide = 14,
  multi = 15,
  exp = 16,
  inExpressionSep = 138,
  _in = 17,
  IterationContext = 18,
  forExpressionBodyStart = 140,
  _return = 20,
  IfExpression = 21,
  ifExpressionStart = 141,
  _if = 22,
  then = 23,
  _else = 24,
  QuantifiedExpression = 25,
  quantifiedExpressionStart = 142,
  some = 26,
  every = 27,
  QuantifiedInExpressions = 28,
  QuantifiedInExpression = 29,
  satisfies = 30,
  Disjunction = 31,
  or = 32,
  Conjunction = 33,
  and = 34,
  Comparison = 35,
  between = 38,
  PositiveUnaryTest = 39,
  PositiveUnaryTests = 41,
  ArithmeticExpression = 43,
  arithmeticPlusStart = 145,
  arithmeticTimesStart = 146,
  arithmeticExpStart = 147,
  arithmeticUnaryStart = 148,
  InstanceOfExpression = 44,
  instance = 45,
  of = 46,
  Type = 47,
  QualifiedName = 48,
  VariableName = 49,
  BacktickIdentifier = 50,
  SpecialType = 51,
  days = 52,
  time = 53,
  duration = 54,
  years = 55,
  months = 56,
  date = 57,
  list = 60,
  context = 63,
  ContextEntryTypes = 64,
  ContextEntryType = 65,
  _function = 67,
  ArgumentTypes = 68,
  ArgumentType = 69,
  PathExpression = 70,
  pathExpressionStart = 154,
  PathName = 71,
  FilterExpression = 73,
  filterExpressionStart = 155,
  FunctionInvocation = 75,
  functionInvocationStart = 156,
  SpecialFunctionName = 76,
  functionInvocationParameters = 157,
  NamedParameters = 77,
  NamedParameter = 78,
  ParameterName = 79,
  PositionalParameters = 80,
  literal = 160,
  nil = 161,
  _null = 81,
  NumericLiteral = 82,
  StringLiteral = 83,
  BooleanLiteral = 84,
  DateTimeLiteral = 85,
  DateTimeConstructor = 86,
  AtLiteral = 87,
  SimplePositiveUnaryTest = 89,
  Interval = 90,
  listStart = 168,
  ParenthesizedExpression = 91,
  List = 92,
  FunctionDefinition = 93,
  functionDefinitionStart = 170,
  FormalParameters = 94,
  FormalParameter = 95,
  external = 96,
  Context = 100,
  contextStart = 172,
  ContextEntry = 101,
  Key = 102,
  PropertyName = 103,
  PropertyIdentifier = 104,
  Expressions = 105,
  UnaryTests = 106,
  not = 108,
  Dialect_camunda = 0
